module.exports = __webpack_public_path__ + "img/rentini-coin.b769ca07.svg";